import { Helmet } from 'react-helmet-async';

import IntegrationCallbackManagerView from 'src/sections/auth/callbacks/integration-callback-view';

export default function IntegrationCallbackManagerPage() {
    return (
        <>
            <Helmet>
                <title>JT: Complete Connection</title>
            </Helmet>

            <IntegrationCallbackManagerView />
        </>
    );
}
